module.exports = __webpack_public_path__ + "assets/img/strength-potion.8ac13c3b.png";